// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___2YxyN","itemsContainer":"styles__itemsContainer___ZbfdX","close":"styles__close___3COaz","userAvatar":"styles__userAvatar___1fffU"};